/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Api_Keys_Toasts_Generate_Loading_DescriptionInputs */

const es_user_profile_api_keys_toasts_generate_loading_description = /** @type {(inputs: User_Profile_Api_Keys_Toasts_Generate_Loading_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor esperá mientras generamos tu nueva clave API…`)
};

const en_user_profile_api_keys_toasts_generate_loading_description = /** @type {(inputs: User_Profile_Api_Keys_Toasts_Generate_Loading_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please wait while we generate your new API key…`)
};

/**
* | output |
* | --- |
* | "Please wait while we generate your new API key…" |
*
* @param {User_Profile_Api_Keys_Toasts_Generate_Loading_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_api_keys_toasts_generate_loading_description = /** @type {((inputs?: User_Profile_Api_Keys_Toasts_Generate_Loading_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Api_Keys_Toasts_Generate_Loading_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_api_keys_toasts_generate_loading_description(inputs)
	return en_user_profile_api_keys_toasts_generate_loading_description(inputs)
});
export { user_profile_api_keys_toasts_generate_loading_description as "user.profile.api_keys.toasts.generate.loading_description" }